import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import { Redirect, useLocation } from 'react-router-dom';

import { OldCheckout } from '../components/Checkout/OldCheckout';
import { actions, operations as checkoutOperations, selectors } from '../ducks/checkout';
import { operations } from '../ducks/purchase';
import { ReviewAndPurchaseStep } from '../components/Checkout/ReviewAndPurchaseStep';
import { CheckoutDetailsStep } from '../components/Checkout/CheckoutDetailsStep';
import { EVENTS, VARIANT_OLD_CHECKOUT, VARIANT_TWO_STEP_CHECKOUT, trackEvent } from '../tracking';
import { actions as billingInfoActions } from '../ducks/billing-info';
import billingInfoSelector from '../ducks/billing-info/selectors';

export const mapDispatchToProps = {
  applyCoupon: checkoutOperations.applyCoupon,
  checkoutError: checkoutOperations.checkoutError,
  checkoutPurchase: checkoutOperations.checkoutPurchase,
  clearNotifications: checkoutOperations.clearNotifications,
  clearPurchaseData: operations.clearPurchaseData,
  fetchCheckoutPreview: checkoutOperations.fetchCheckoutPreview,
  handleCheckoutSuccess: checkoutOperations.handleCheckoutSuccess,
  initialize: operations.initialize,
  resetPreview: () => actions.resetPreviewAction,
  setPurchase: operations.setPurchase,
};

export const CheckoutContainer = (props) => {
  const flags = useFlags();
  const { pathname } = useLocation();

  const hasUsageSubscription = props.activeSubscriptions?.toArray()
    .some((subscription) => subscription.plan.isUsage() as boolean);
  const twoStepCheckoutEnabled = flags.webUiTwoStepCheckoutFlow ||
    flags.webUiUsageBasedBilling || hasUsageSubscription;

  const billingInfo = useSelector(billingInfoSelector);

  useEffect(() => {
    trackEvent(
      EVENTS.CHECKOUT_LOAD_PAGE,
      twoStepCheckoutEnabled ? VARIANT_TWO_STEP_CHECKOUT : VARIANT_OLD_CHECKOUT,
    );
  }, [twoStepCheckoutEnabled]);

  if (twoStepCheckoutEnabled) {
    if (pathname === '/billing/checkout' && !billingInfo?.paymentMethod?.isValid) {
      return <Redirect to="/billing/details" />;
    }

    return (
      <Switch>
        <Route
          path="/billing/details"
          render={() => (
            <CheckoutDetailsStep
              allPlans={props.allPlans}
              orderItems={props.orderItems}
            />
          )}
        />
        <Route
          path="/billing/checkout"
          render={() => (
            <ReviewAndPurchaseStep
              activeSubscriptions={props.activeSubscriptions}
              allPlans={props.allPlans}
              applyCoupon={props.applyCoupon}
              checkoutError={props.checkoutError}
              checkoutPreview={props.checkoutPreview}
              checkoutPurchase={props.checkoutPurchase}
              clearNotifications={props.clearNotifications}
              clearPurchaseData={props.clearPurchaseData}
              couponCode={props.couponCode}
              fetchCheckoutPreview={props.fetchCheckoutPreview}
              orderItems={props.orderItems}
              user={props.user}
            />
          )}
        />
      </Switch>
    );
  }

  return (
    <OldCheckout
      {...props}
    />
  );
};

export default connect(selectors.checkoutSelector, mapDispatchToProps)(CheckoutContainer);
